import React, { useState } from 'react';

// Comps
import AccountForm from '../AccountForm/AccountForm';
import AccountFormHeader from '@project-stories/ecommerce/Account/AccountFormHeader/AccountFormHeader';
import { Paragraph } from '@project-stories/elements/Paragraph/Paragraph';
import { Link } from '@arctheme-components/elements/Link/Link';

type Props = {
    section: any;
    signUpFields: any;
    headerColorSchema?: string;
    blockSettings?: any;
};

export const TwoColumnWithImage = ({ section, signUpFields, headerColorSchema, blockSettings }: Props) => {
    const {
        // Typography
    } = section;

    // Extract block settings
    const loginForm = blockSettings?.loginForm || {};
    const sideImage = blockSettings?.sideImage || {};
    const registerCta = blockSettings?.registerCta || {};
    // Image settings
    const imagePosition = sideImage.image_position || 'right';
    const imageWidth = sideImage.image_width || 50;
    const contentWidth = 100 - imageWidth;
    const showOverlay = sideImage.show_overlay || false;
    const overlayColor = sideImage.overlay_color || '#000000';
    const overlayOpacity = sideImage.overlay_opacity || 30;
    
    // States
    const [showCustomFields, setShowCustomFields] = useState(true);

    // Determine image URL based on screen size
    const getResponsiveImageUrl = () => {
        return {
            desktop: sideImage.side_image ? sideImage.side_image : '',
            mobile: sideImage.side_image_mobile ? sideImage.side_image_mobile : sideImage.side_image || ''
        };
    };
    
    const imageUrls = getResponsiveImageUrl();

    return (
        <div className="flex flex-col lg:flex-row w-full">
            {/* Login Form Column */}
            <div 
                className={`w-full lg:w-[${contentWidth}%] p-6  max-lg:order-2 ${
                    imagePosition === 'left' ? 'lg:order-2' : 'lg:order-1'
                }`}
            >
                <div className="md:max-w-[480px] mx-auto">
                    <AccountFormHeader
                        title={loginForm.title_login}
                        tagline={loginForm.tagline_login}
                        titleType={'h3'}
                        taglineType={'b4'}
                        colorSchema={loginForm.header_color_schema || headerColorSchema}
                    />

                    <AccountForm
                        section={{
                            ...section,
                            ...loginForm
                        }}
                        isRegister={false}
                        showCustomFields={showCustomFields}
                        blockSettings={blockSettings}
                    />

                    {/* Register CTA */}
                    {registerCta.show_register_cta && (
                        <div className="mt-12 border-t border-gray-200 pt-8">
                            <p
                                className={`mb-4 ${registerCta.title_register_style}`}
                                style={{ color: registerCta.title_register_color || '#000' }}
                            >
                                {registerCta.title_register_cta}
                            </p>

                            <Paragraph 
                                text={registerCta.tagline_register_cta}
                                type="b4 mb-6"
                            />
                            <Link
                                link="/account/register"
                                classes={`button button-${registerCta.button_style_register_cta} w-full text-center min-h-[60px] !text-lg block`}
                            >
                                {registerCta.button_label_register_cta}
                            </Link>
                        </div>
                    )}
                </div>
            </div>

            {/* Image Column */}
            <div
                className={`w-full lg:w-[${imageWidth}%] min-h-[300px] lg:min-h-[600px] relative max-lg:order-1 ${
                    imagePosition === 'left' ? 'lg:order-1' : 'lg:order-2'
                }`}
            >
                {/* Mobile Image */}
                <div 
                    className="absolute inset-0 w-full h-full bg-contain bg-no-repeat bg-center lg:hidden" 
                    style={{ backgroundImage: `url(${imageUrls.mobile})` }}
                >
                    {showOverlay && (
                        <div 
                            className="absolute inset-0" 
                            style={{ backgroundColor: overlayColor, opacity: overlayOpacity / 100 }}
                        ></div>
                    )}
                </div>
                
                {/* Desktop Image */}
                <div 
                    className="absolute inset-0 w-full h-full bg-contain bg-no-repeat bg-center hidden lg:block" 
                    style={{ backgroundImage: `url(${imageUrls.desktop})` }}
                >
                    {showOverlay && (
                        <div 
                            className="absolute inset-0" 
                            style={{ backgroundColor: overlayColor, opacity: overlayOpacity / 100 }}
                        ></div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TwoColumnWithImage;